import { Component, viewChild } from '@angular/core';
import { OptionModel, SelectListComponent } from '../select-list/select-list.component';
import log from 'loglevel';
import { Tag } from 'src/app/entities/tag/tag';
import { Client } from 'src/app/entities/client/client';
import { Project } from 'src/app/entities/project/project';
import { User } from 'src/app/entities/user/user';


/**
 * Class that provides common functionality for other components.
 */
@Component({
  selector: 'app-base',
  imports: [],
  templateUrl: './base.component.html',
  styleUrl: './base.component.scss'
})
export class BaseComponent {


  /**
   * Logger for base component.
   */
  protected logger = log.getLogger('BaseComponent');


  /**
   * List of options to display on the select
   */
  protected optionsFromTags: OptionModel[] = [];


  /**
   * List of options to display on the select
   */
  protected optionsFromProjects: OptionModel[] = [];


  /**
   * List of options to display on the select
   */
  protected optionsFromClients: OptionModel[] = [];


  /**
   * List of options to display on the select
   */
  protected optionsFromMembers: OptionModel[] = [];


  /**
   * Reference to the 'tags' select list component.
   */
  protected selectListTags = viewChild<SelectListComponent>('selectListTags');

  /**
   * Reference to the 'projects' select list component.
   */
  protected selectListProjects = viewChild<SelectListComponent>('selectListProjects');


  /**
   * Reference to the 'clients' select list component.
   */
  protected selectListClients = viewChild<SelectListComponent>('selectListClients');


  /**
   * Reference to the 'members' select list component.
   */
  protected selectListMembers = viewChild<SelectListComponent>('selectListMembers');


  /**
   * Sets the options for the 'tags' select component.
   */
  protected setOptionsFromTags(tags: Tag[]): void {
    this.optionsFromTags = tags.map((tag) => {
      return { value: tag.id, view: tag.label }
    }) || [];
  }


  /**
   * Sets the options for the 'projects' select component.
   */
  protected setOptionsFromProjects(projects: Project[]): void {
    this.optionsFromProjects = projects.map((project) => {
      return { value: project.id, view: project.name, disabled: !project.permissions.track }
    }) || [];
  }


  /**
   * Sets the options for the 'tags' select component.
   */
  protected setOptionsFromClients(clients: Client[]): void {
    this.optionsFromClients = clients.map((client) => {
      return { value: client.id, view: client.name }
    }) || [];
  }


  /**
   * Sets the options for the 'members' select component.
   */
  protected setOptionsFromMembers(users: User[]): void {
    this.optionsFromMembers = users.map((user) => {
      return { value: user.id, view: user.name }
    }) || [];
  }


  /**
   * Sets the selected option for a given select component.
   */
  protected setSelectedOption(
    componentRef: SelectListComponent | undefined,
    value?: string | null,
    values?: string[] | null
  ): void {
    if (!componentRef) {
      this.logger.error('Component reference not found.');

      return;
    };

    const component = componentRef;

    if (value && !values) component.selectedOption.setValue(value);

    if (values && !value) component.selectedOptions.setValue(values);

  }
}
